import React, {useCallback} from 'react';
import {DropDownButton} from './DropDownButton';
import FilterSearch from '../elements/FilterSearch';
import { useFilterUI } from '../product/GridFilter/FilterDataProvider.client';

export function FilterDropdown({Disclosure, ChevronDownIcon}) {
  const filterUI = useFilterUI();
  
  const { filters, selectedFilters, updateSelectedFilters } = filterUI;
  const handleChange = useCallback(
    (id, name, isChecked, type) => {
      if ('radio' === type) {
        selectedFilters[id] = [name]
      } else {
        selectedFilters[id] = selectedFilters[id] instanceof Array ? selectedFilters[id] : [];
        isChecked ? selectedFilters[id] = [...selectedFilters[id], name] : selectedFilters[id]= selectedFilters[id].filter(item => item !== name);
      }
      
      updateSelectedFilters({...selectedFilters});
    }, [updateSelectedFilters]
  );
  
  return (
    <> 
      {filters && filters.map((section) => (
        <Disclosure
          as="div"
          key={section.id}
          defaultOpen
          className="border-b-borderLight1 px-2 md:px-0 xl:px-4 lg:px-2 border-gray-200 py-6"
        >
          {({open}) => (
            <div>
              <h3 className="-my-3 flow-root">
                <Disclosure.Button className="flex w-full items-center justify-between px-2 rounded-md py-3">
                  <DropDownButton
                    open={open}
                    name={section.name}
                    ChevronDownIcon={ChevronDownIcon}
                 />
                </Disclosure.Button>
              </h3>
              <Disclosure.Panel className="pt-6">
                <div className="space-y-4">
                  {section.options.map((option, optionIdx) => (
                    option && option.code && 
                      <FilterSearch
                        key={option.code}
                        id={section.id}
                        isChecked={selectedFilters[section.id] ? selectedFilters[section.id].indexOf(option.code) !== -1 : false}
                        optionIdx={optionIdx}
                        option={option}
                        handleChange={handleChange}
                        type={section?.type || 'radio'}
                     />
                  ))}
                </div>
              </Disclosure.Panel>
            </div>
          )}
        </Disclosure>
      ))}
    </>
  );
}
